<template>
    <div v-if="1">
    <!-- <div v-if="config.gocheckin_feature == 1 || config.appointment_feature == 1 || config.pos_feature"> -->
    <div class="vx-breadcrumb mb-6">
        <ul class="flex flex-wrap items-center">
            <li class="inline-flex items-end">
                <router-link to="/after-login">
                    <feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" />
                </router-link>
                <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
            </li>
            <li class="inline-flex items-end">
              <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Services</span>
            </li>
        </ul>
    </div>
    <div class="overflow-hidden shadow-md rounded-item">
      <div id="service-list" class="rounded-item relative vs-con-loading__container w-full overflow-auto">
          <vs-sidebar class="items-no-padding" parent="#service-list" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="active" id="service-list-sidebar">
              <div class="flex justify-between align-center p-6">
                  <h3 class="font-bold">Categories</h3>
                  <vs-button type="filled" color="primary" icon-pack="feather" icon="icon-plus"  class="ml-4 add-cate-btn" @click.stop="addNewData" v-if="typeCate != 'combo'"></vs-button>
              </div>

              <vs-tabs class="category-tabs">
                <vs-tab label="SHOW" @click="listActive">
                  <div v-if="dragListType && config && dragListType.length > 0" class="category-item-list-container">
                    <vs-list class="bg-custom py-0">
                      <draggable v-model="dragListType" :scroll-sensitivity="250" :force-fallback="true" handle=".move-btn" @end="getOrderList">
                        <transition-group>
                          <div class="list-item bg-custom" v-for="cate in dragListType" :key="'E' + cate.id" @click="updateActiveStaff(cate)">
                            <vs-list-item @click="updateCategoryList" class="mx-4 my-4">
                              <category-item class="cursor-pointer" :currentPage="currentPage" :typeCate="typeCate" :serviceData="cate" @EditCate="editCate" @DeleteCategory="deleteCategory" :isActive="isActive(cate.id)"></category-item>
                            </vs-list-item>
                          </div>
                        </transition-group>
                      </draggable>
                    </vs-list>
                  </div>
                </vs-tab>
                <vs-tab label="HIDDEN" @click="listInActive">
                  <div v-if="dragListType && config && dragListType.length > 0" class="category-item-list-container">
                    <vs-list class="bg-custom py-0">
                      <draggable v-model="dragListType" :scroll-sensitivity="250" :force-fallback="true" handle=".move-btn" @end="getOrderList">
                        <transition-group>
                          <div class="list-item bg-custom" v-for="cate in dragListType" :key="'E' + cate.id" @click="updateActiveStaff(cate)">
                            <vs-list-item @click="updateCategoryList" class="mx-4 my-4">
                              <category-item class="cursor-pointer" :currentPage="currentPage" :typeCate="typeCate" :serviceData="cate" @EditCate="editCate" @DeleteCategory="deleteCategory" :isActive="isActive(cate.id)"></category-item>
                            </vs-list-item>
                          </div>
                        </transition-group>
                      </draggable>
                    </vs-list>
                  </div>
                </vs-tab>
              </vs-tabs>
          </vs-sidebar>

          <!-- RIGHT COLUMN -->
          <div class="staff__bg app-fixed-height service-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0 bg-custom overflow-auto" style="min-width: 850px;" v-if="typeCate == 'product'">
            <product-content @GetListByStatus="getListByStatus" :servicesList="productListByType" @UpdateProduct="editProduct" @AddProduct="addProduct" :key="activeStaffData.id + '-product-content-' + content_key" :activeCategory="activeStaffData" :isEmptyList="isEmptyList"></product-content>
          </div>
          <div class="staff__bg app-fixed-height service-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0 bg-custom overflow-auto" style="min-width: 850px;" v-if="typeCate == 'service'">
            <service-content @GetListByStatus="getListByStatus" :servicesList="serviceListByType.items" @UpdateService="editService" @AddService="addService" :key="activeStaffData.id + '-service-content-' + content_key" :activeCategory="activeStaffData" :isEmptyList="isEmptyList"></service-content>
          </div>
          <div class="staff__bg app-fixed-height service-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0 bg-custom overflow-auto" style="min-width: 850px;" v-if="typeCate == 'combo'">
            <combo-content @GetListByStatus="getListByStatus" :servicesList="comboListByType.items" @UpdateCombo="editCombo" @AddCombo="addCombo" :key="activeStaffData.id + '-combo-content-' + content_key" :activeCategory="activeStaffData" :isEmptyList="isEmptyList"></combo-content>
          </div>
          <div class="staff__bg app-fixed-height service-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0 bg-custom overflow-auto" style="min-width: 850px;" v-if="typeCate == 'gift_card'">
            <gift-card-content></gift-card-content>
          </div>
          <div class="staff__bg app-fixed-height service-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0 bg-custom overflow-auto" style="min-width: 850px;" v-if="typeCate == 'custom'">
            <custom-content></custom-content>
          </div>
      </div>

      <div class="update-add-sidebar">
          <vs-add-category :isExistName="isExistName" :errMessage="err_message" :currentPage="currentPage" :addCateConfig="addCateConfig" :serviceData="activeStaffData" @CloseSidebar="closeSidebar" @SubmitData="addCategory" :key="'D' + abc"></vs-add-category>
          <vs-update-category :typeCate="typeCate" :isExistName="isExistName1" :errMessage="err_message_1" :currentPage="currentPage" :sidebarConfig="sidebarConfig" :serviceData="activeStaffData" @UpdateCategory="updateCategory" @CloseSidebar="closeSidebar" :key="'C' + bcd"></vs-update-category>
          <div v-show="typeCate == 'service'">
            <vs-add-service :activeStaffData="activeStaffData" :addServiceConfig="addServiceConfig" :activeServiceData="activeServiceData" :serviceData="allCategoryList" @AddService="addServiceInfo" @CloseSidebar="closeServiceSidebar" :key="'A' + abc"></vs-add-service>
            <vs-update-services ref="updateServiceSidebar" :serviceConfig="serviceConfig" :cateName="cateName" :cateData="dragListType" :serviceData="activeServiceData" @CloseSidebar="closeServiceSidebar" @UpdateServiceInfo="editServiceInfo" :key="'B' + update_service_key"></vs-update-services>
          </div>
          <div v-show="typeCate == 'product'">
            <vs-add-product :activeStaffData="activeStaffData" :addProductConfig="addProductConfig" :activeServiceData="activeServiceData" :serviceData="allCategoryList" @AddProduct="addProductInfo" @CloseSidebarProduct="closeSidebarProduct" :key="add_product_key"></vs-add-product>
            <vs-update-products :productConfig="productConfig" :cateName="cateProName" :cateData="dragListType" :serviceData="activeServiceData" @CloseSidebarProduct="closeSidebarProduct" @UpdateProductInfo="editProductInfo" :key="'E' + update_product_key"></vs-update-products>
          </div>
          <div v-show="typeCate == 'combo'">
            <vs-add-combo :addComboConfig="addComboConfig" @AddCombo="addComboInfo" :serviceData="allCategoryList" :activeServiceData="activeServiceData" :activeStaffData="activeStaffData" @CloseSidebarCombo="closeSidebarCombo" :key="'G' + add_combo_key"></vs-add-combo>
            <vs-update-combo :comboConfig="comboConfig" @UpdateCombo="editComboInfo" :cateData="dragListType" :serviceData="activeServiceData" :activeStaffData="activeStaffData" @CloseSidebarCombo="closeSidebarCombo" :key="'H' + update_combo_key"></vs-update-combo>
          </div>
      </div>
    </div>
      <vs-popup class="holamundo delete-group delete-popup" title="Update Category" :active.sync="comfirmInactiveCate">
        <div class="text-center">
            <h4>You're trying to deactivate a category which included in 
                <span v-for="(combo, index) in comboListHasCurrentCate" :key="index" class="font-bold">
                  <span v-if="index == comboListHasCurrentCate.length - 1">{{combo}}</span>
                  <span v-else>{{combo}}, </span>
                </span>. <br />Are you sure to still deactivate it?
            </h4>
            <div class="flex flex-wrap justify-center align-center p-6 mt-6">
            <vs-button class="mr-6 align-center delete-responsive" @click="updateCategory(updateCategoryData)">Ok</vs-button>
            <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="comfirmInactiveCate = false">Cancel</vs-button>
            </div>
        </div>
      </vs-popup>
      <vs-popup class="holamundo delete-group delete-popup" title="Update Service" :active.sync="comfirmInactiveService">
        <div class="text-center">
            <h4>You're trying to deactivate a service which included in 
                <span v-for="(combo, index) in comboListHasCurrentService" :key="index" class="font-bold">
                  <span v-if="index == comboListHasCurrentService.length - 1">{{combo}}</span>
                  <span v-else>{{combo}}, </span>
                </span>. <br />Are you sure to still deactivate it?
            </h4>
            <div class="flex flex-wrap justify-center align-center p-6 mt-6">
            <vs-button class="mr-6 align-center delete-responsive" @click="editServiceInfo(updateServiceData)">Ok</vs-button>
            <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="comfirmInactiveService = false">Cancel</vs-button>
            </div>
        </div>
      </vs-popup>
    </div>
    <div v-else>
    <vx-card>
      <h2>
        This is for Go Check In full version, please contact us for more info at
        <b>832-968-6668</b>
      </h2>
    </vx-card>
  </div>
</template>
<script>
    import draggable from 'vuedraggable'
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    export default {
        components: {
            VuePerfectScrollbar,draggable
        },
        data() {
          return {
              sidebarConfig      : { isOpen: false},
              serviceConfig      : { isOpen: false },
              addCateConfig      : { isOpen: false },
              addServiceConfig   : { isOpen: false },
              addProductConfig   : { isOpen: false },
              productConfig      : { isOpen: false },
              addComboConfig     : { isOpen: false },
              comboConfig        : { isOpen: false },
              active              : true,
              categoriesList: [],
              activeStaff         : null,
              activeStaffData     : {},
              activeServiceData   : {},
              cateName: {},
              dragList: [],
              dragListType: [],
              orderedList : [],
              settings            : {
                maxScrollbarLength : 60,
                wheelSpeed         : 0.70,
              },
              clickNotClose       : true,
              avatarColor         : '',
              abc: 0,
              bcd: 0,
              add_product_key: 0,
              update_product_key: 0,
              update_service_key: 0,
              add_combo_key: 0,
              update_combo_key: 0,
              currentPage: 1,
              itemsPerPage: 10,
              isExistName: false,
              isExistName1: false,
              err_message: '',
              err_message_1: '',
              items: [
              {
                title: 'Home',
                url: '/',
                icon: "HomeIcon",
              },
              {
                title: 'Services',
                active: true,
              },
            ],
            action_type: '',
            isOpenLoading: false,
            loaded_data_num: 0,
            isEmptyList: false,
            typeCate: 'service',
            cateProName: '',
            status: 2,
            serviceStatus: 1,
            content_key: 0,
            comboListHasCurrentCate: [],
            comboListHasCurrentService: [],
            comboObj: null,
            comfirmInactiveCate: false,
            comfirmInactiveService: false,
            updateCategoryData: null,
            updateServiceData: null,
            comboListActive: []
          }
        },
        watch:{
          categoryList: {
            immediate: true,
            deep: true,
            handler: function() {
              if(this.categoryList && this.categoryList.items){
                this.dragListType = this.categoryList.items;
                if(this.dragListType.length > 0) {
                  for(let i = 0; i < this.dragListType.length; i++) {
                    if(this.dragListType[i].type == 'combo') {
                      this.comboObj = {
                        category_id: this.dragListType[i].id,
                        status: 1
                      };
                      break;
                    }
                  }
                  this.isEmptyList = false;
                  this.content_key++;
                } else {
                  this.isEmptyList = true;
                  this.content_key++;
                }
              }
            }
          },
          loaded_data_num: {
            immediate: true,
            handler() {
              if(this.loaded_data_num >= 2 || this.isEmptyList) {
                this.closeLoading();
              } else {
                this.action_type = "Get data";
                if(!this.isOpenLoading) {
                  this.openLoadingInDiv();
                }
              }
            }
          },
        },
        methods: {
          // listAll(){
          //   if(!this.isOpenLoading) {
          //     this.openLoadingInDiv();
          //   }
          //   const obj={
          //     type: this.typeCate
          //   }
          //   this.action_type = "Get list";
          //   this.$store.dispatch('serviceList/GET_CATEGORY_LIST_BY_TYPE',obj).then(()=> {
          //     if(this.$store.getters["serviceList/allCategoryList"].length > 0) {
          //       this.updateActiveStaff(this.$store.getters["serviceList/allCategoryList"][0]);
          //     }
          //     this.status = 0;
          //     this.closeLoading();
          //   })
          // },
          listActive(){
            if(!this.isOpenLoading) {
              this.openLoadingInDiv();
            }
            const obj={
              // type: this.typeCate,
              status: 2,
              // type: 'pos'
            }
            // if(this.config && this.config.pos_feature == 1) {
            //   obj.type = 'pos';
            // }
            this.action_type = "Get list";
            // this.$store.dispatch('serviceList/GET_ALL_CATEGORY_LIST',obj).then(()=> {
            //   if(this.$store.getters["serviceList/allCategoryList"].length > 0) {
            //     this.updateActiveStaff(this.$store.getters["serviceList/allCategoryList"][0]);
            //   }
            //   this.status = 2;
            //   this.closeLoading();
            // })
            this.$store.dispatch('serviceList/GET_CATEGORY_LIST',obj).then(()=> {
              if(this.$store.getters["serviceList/categoryList"].items && this.$store.getters["serviceList/categoryList"].items.length > 0) {
                this.updateActiveStaff(this.$store.getters["serviceList/categoryList"].items[0]);
              }
              this.status = 2;
              this.closeLoading();
            })
          },
          listInActive(){
            if(!this.isOpenLoading) {
              this.openLoadingInDiv();
            }
            const obj={
              // type: this.typeCate,
              status: 1,
              // type: 'pos'
            }
            // if(this.config && this.config.pos_feature == 1) {
            //   obj.type = 'pos';
            // }
            this.action_type = "Get list";
            // this.$store.dispatch('serviceList/GET_ALL_CATEGORY_LIST',obj).then(()=> {
            //   if(this.$store.getters["serviceList/allCategoryList"].length > 0) {
            //     this.updateActiveStaff(this.$store.getters["serviceList/allCategoryList"][0]);
            //   }
            //   this.status = 1;
            //   this.closeLoading();
            // })
            this.$store.dispatch('serviceList/GET_CATEGORY_LIST',obj).then(()=> {
              if(this.$store.getters["serviceList/categoryList"].items && this.$store.getters["serviceList/categoryList"].items.length > 0) {
                this.updateActiveStaff(this.$store.getters["serviceList/categoryList"].items[0]);
              }
              this.status = 1;
              this.closeLoading();
            })
          },
          // changeTab(){
          //   this.status = 2;
          //   const obj = {
          //     status: this.status,
          //     type: this.typeCate
          //   }
          //   this.openLoadingInDiv();
          //   this.$store.dispatch("serviceList/GET_CATEGORY_LIST_BY_TYPE", obj).then(() => {
          //     this.dragListType = this.$store.state.serviceList.allCategoryList;
          //     if(this.$store.getters["serviceList/allCategoryList"].length > 0) {
          //       this.updateActiveStaff(this.$store.getters["serviceList/allCategoryList"][0]);
          //     } else {
          //       this.isEmptyList = true;
          //     }
          //     this.loaded_data_num++;
          //     this.closeLoading();
          //   })
          // },
          getOrderList(){
            this.orderedList = [];
            for(let i = 0; i < this.dragListType.length; i++){
              this.orderedList.push(this.dragListType[i].id);
            }
            // for(let i = this.dragListType.length - 1; i >= 0; i--){
            //   this.orderedList.push(this.dragListType[i].id);
            // }
            const obj = {
              // type: this.typeCate,

              categories: this.orderedList.length > 0 ? String(this.orderedList) : '',
              statusFilter: this.status,
              // list_type: 'pos'
            }
            // if(this.config && this.config.pos_feature == 1) {
            //   obj.list_type = 'pos';
            // }
            if(!this.isOpenLoading) {
              this.openLoadingInDiv();
            }
            this.$store.dispatch("serviceList/DRAG_CATEGORY", obj).then(() => {
              // this.$store.dispatch("serviceList/GET_ALL_CATEGORY_LIST", { status: this.status }).then(() => {
              //   this.closeLoading();
              // }); 
              let temp = {
                status: this.status
              }
              // if(this.config && this.config.pos_feature == 1) {
              //   temp.type = 'pos';
              // }
              this.$store.dispatch("serviceList/GET_CATEGORY_LIST", temp).then(() => {
                this.closeLoading();
              });
            })
          },
          openLoadingInDiv(){
            this.$vs.loading({
              container: '#app',
              scale: 0.8
            })
            if(this.loadTime){
              clearTimeout(this.loadTime);
              this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
              if(this.isOpenLoading) {
                this.closeLoading();
                this.$vs.dialog({
                  color: 'danger',
                  title: 'Notification',
                  text: this.action_type + ' failed',
                  acceptText: 'OK'
                })
              }
            }, 10000);
          },
          closeLoading() {
            this.isOpenLoading = false;
            setTimeout( ()=> {
              this.$vs.loading.close('#app > .con-vs-loading')
            }, 700)
          },
            updateCategoryList(cate){
              const obj ={
                id: cate.id,
                priority: cate.priority
              }
              if(!this.isOpenLoading) {
                this.openLoadingInDiv();
              }
              this.action_type = 'Update category';
              this.$store.dispatch("serviceList/UPDATE_CATEGORY",obj).then(() => {
                this.closeLoading();
              })
            },
            getListByStatus(data){
              this.loaded_data_num = 1;
              // const obj = {
              //   category_id: this.activeStaff,
              //   status: data.id
              // }
              // if(!this.isOpenLoading) {
              //   this.openLoadingInDiv();
              // }
              // this.action_type = "Get list";
              this.serviceStatus = data.id
              if(this.typeCate == 'product'){
                this.getProduct();
                // this.$store.dispatch("serviceList/GET_PRODUCT_LIST_POS", obj).then(() => {
                //   this.closeLoading();
                //   this.loaded_data_num++;
                // })
              }
              if(this.typeCate == 'service'){
                this.getService();
                // this.$store.dispatch("serviceList/GET_SERVICE_LIST_POS", obj).then(() => {
                //   this.closeLoading();
                //   this.loaded_data_num++;
                // })
              }
              if(this.typeCate == 'combo'){
                this.getCombo();
                // this.$store.dispatch("serviceList/GET_COMBO_LIST_POS", obj).then(() => {
                //   this.closeLoading();
                //   this.loaded_data_num++;
                // })
              }
            },
            updateActiveStaff(cate, isFromEdit = false) {
              if(isFromEdit == false) {
                this.serviceStatus = 1;
              }
              this.loaded_data_num = 1;
              if(cate) {
                this.activeStaff = cate.id;
                this.activeStaffData = cate;
                if(cate.type) {
                  this.typeCate = cate.type;
                } else {
                  this.typeCate = 'service';
                }
                if(this.typeCate == 'product'){
                  this.getProduct();
                }
                if(this.typeCate == 'service'){
                  this.getService();
                }
                if(this.typeCate == 'combo'){
                  this.getCombo();
                }
                if(this.typeCate == 'gift_card' || this.typeCate == 'custom') {
                  this.loaded_data_num = 2;
                }
              }
            },
            getCombo(){
              const obj = {
                category_id: this.activeStaff,
                status : this.serviceStatus
              }
              this.$store.dispatch("serviceList/GET_COMBO_LIST_POS", obj).then(() => {
                this.loaded_data_num++;
              })
            },
            getProduct(){
              const obj = {
                category_id: this.activeStaff,
                status : this.serviceStatus
              }
              this.$store.dispatch("serviceList/GET_PRODUCT_LIST_POS", obj).then(() => {
                this.loaded_data_num++;
              })
            },
            getService(){
              // this.serviceStatus = 1;
              let obj = {
                category_id: (this.activeStaff == 999999 || this.activeStaff == '' || this.activeStaff == undefined) ? null : this.activeStaff,
                status : this.serviceStatus
              }
              if(this.activeStaff == 999999 || this.activeStaff == '' || this.activeStaff == undefined) {
                obj = {
                  status : this.serviceStatus
                }
              }
              this.$store.dispatch("serviceList/GET_SERVICE_LIST_POS", obj).then((service_list) => {
                if(this.comboObj) {
                  this.$store.dispatch('serviceList/GET_COMBO_LIST_ACTIVE', this.comboObj).then((combo_list) => {
                    this.comboListActive = combo_list.items;
                    this.getComboNameHasCurCate(service_list.items, combo_list.items);
                    // console.log('List combo has current category: ');
                    // console.log(this.comboListHasCurrentCate);
                    this.loaded_data_num++;
                  })
                }
              })
            },

            // Check when inactive category
            getComboNameHasCurCate(service_list, combo_list) {
              this.comboListHasCurrentCate = [];
              if(service_list.length > 0 && combo_list.length > 0) {
                for(let i = 0; i < combo_list.length; i++) {
                  if(this.checkCurrentCombo(combo_list[i].combo_item, service_list)) {
                    this.comboListHasCurrentCate.push(combo_list[i].name);
                  }
                }
              }
            },
            // Check when inactive category
            checkCurrentCombo(items_in_combo, service_list) {
              if(items_in_combo.length > 0) {
                for(let i = 0; i < items_in_combo.length; i++) {
                  if(this.checkExistService(items_in_combo[i], service_list)) {
                    return true;
                  }
                }
              }
              return false;
            },
            // Check when inactive category
            checkExistService(item, service_list) {
              if(item) {
                for(let i = 0; i < service_list.length; i++) {
                  if(item.item_id == service_list[i].id) {
                    return true;
                  }
                }
              }
              return false;
            },
            // Check when inactive service
            checkCurrentServiceInCombo(service) {
              this.comboListHasCurrentService = [];
              if(service && this.comboListActive && this.comboListActive.length > 0) {
                for(let i = 0; i < this.comboListActive.length ; i++) {
                  let items_in_combo = this.comboListActive[i].combo_item;
                  for(let j = 0; j < items_in_combo.length; j++) {
                    if(items_in_combo[j].item_id == service.id) {
                      this.comboListHasCurrentService.push(this.comboListActive[i].name);
                      j = items_in_combo.length;
                    }
                  }
                }
              }
            },
            isActive(id) {
                return id == this.activeStaff;
            },
            closeSidebar() {
                this.sidebarConfig.isOpen = false;
                this.addCateConfig.isOpen = false;
                this.isExistName = false;
                this.isExistName1 = false;
                this.err_message = '';
                this.err_message_1 = '';
            },
            closeSidebarProduct(){
              this.productConfig.isOpen = false;
              this.addProductConfig.isOpen = false;
              document.getElementById("service-list").click();
            },
            closeSidebarCombo(){
              this.addComboConfig.isOpen = false;
              this.comboConfig.isOpen = false;
              document.getElementById("service-list").click();
            },
            closeServiceSidebar() {
              this.serviceConfig.isOpen = false;
              this.addServiceConfig.isOpen = false;
              document.getElementById("service-list").click();
            },
            editService(service) {
              this.activeServiceData = {...service};
              this.activeServiceData.image_url = this.activeServiceData.image_path && this.activeServiceData.image_path != "null" ? `${this.activeServiceData.image_base_url}/${this.activeServiceData.image_path}` : null;
              this.activeServiceData.color_code = this.activeStaffData.color_detail ? this.activeStaffData.color_detail.color_code : null;
              for(let i=0;i<this.dragListType.length;i++){
                if(service.category_id == this.dragListType[i].id){
                  this.cateName = this.dragListType[i];
                }
              }
              this.serviceConfig.isOpen = true;
              this.update_service_key++;
            },
            editProduct(product){
              this.activeServiceData = product
              this.cateProName = product.category_name
              this.productConfig.isOpen = true;
              this.update_product_key++;
            },
            editCombo(combo){
              this.activeServiceData = combo
              this.comboConfig.isOpen = true
              this.update_combo_key++;
            },
            editCate(data) {
              this.activeStaffData = {...data};
              this.activeStaffData.image_url = this.activeStaffData.image_path && this.activeStaffData.image_path != "null" ? `${this.activeStaffData.image_base_url}/${this.activeStaffData.image_path}` : null;
              this.activeStaffData.color_code = this.activeStaffData.color_detail ? this.activeStaffData.color_detail.color_code : null;
              this.sidebarConfig.isOpen = true;
              this.bcd++;
            },
            addNewData() {
                this.addCateConfig.isOpen = true;
            },
            addService(){
                this.addServiceConfig.isOpen = true;
                this.abc++;
            },
            addProduct(){
                this.addProductConfig.isOpen = true;
                this.add_product_key++;
            },
            addCombo(){
                this.addComboConfig.isOpen = true;
                this.add_combo_key++;
            },
            addCategory(data){
              if(!this.isOpenLoading) {
                this.openLoadingInDiv();
              }
              this.action_type = 'Add category';
              // data.list_type = 'pos';
              data.type = 'service';
              // data.type = this.typeCate;
              data.statusFilter = this.status
              this.$store.dispatch("serviceList/ADD_CATEGORY", data).then(() => {
                this.abc++;
                this.isExistName = false;
                if(this.addCateConfig.isOpen) {
                  this.closeSidebar();
                }
                this.dragListType = this.$store.state.serviceList.categoryList.items;
                if(this.$store.getters["serviceList/categoryList"].items && this.$store.getters["serviceList/categoryList"].items.length > 0) {
                  this.updateActiveStaff(this.$store.getters["serviceList/categoryList"].items[0]);
                } else {
                  this.isEmptyList = true;
                }
                if(this.isOpenLoading) {
                  this.closeLoading();
                }
                // this.loaded_data_num++;
                this.$vs.notify({
                  title:'Notification',
                  text:'Add Category Success',
                  color:'success',
                  position:'top-right'})
              }).catch((err) => {
                this.abc++;
                this.isExistName = true;
                this.err_message = err;
                this.closeLoading();
              })
            },
            updateCategory(data){
              this.updateCategoryData = data;
              if(data.status == 1 && this.comboListHasCurrentCate.length > 0 && this.comfirmInactiveCate == false && this.activeStaffData.status != 1) {
                this.comfirmInactiveCate = true;
              } else {
                if(!this.isOpenLoading) {
                  this.openLoadingInDiv();
                }
                this.action_type = 'Update category';
                data.type = this.typeCate;
                // data.list_type = 'pos';
                data.statusFilter = this.status
                this.$store.dispatch("serviceList/UPDATE_CATEGORY", data).then(() => {
                  this.bcd++;
                  this.isExistName1 = false;
                  if(this.sidebarConfig.isOpen) {
                    this.closeSidebar();
                  }
                  this.dragListType = this.$store.state.serviceList.categoryList.items;
                  if(data.status != this.status){
                    if(this.$store.getters["serviceList/categoryList"].items && this.$store.getters["serviceList/categoryList"].items.length > 0) {
                      this.updateActiveStaff(this.$store.getters["serviceList/categoryList"].items[0]);
                    } else {
                      this.isEmptyList = true;
                    }
                  }
                  if(this.isOpenLoading) {
                    this.closeLoading();
                  }
                  this.comfirmInactiveCate = false;
                  this.$vs.notify({
                    title:'Notification',
                    text:'Update Category Success',
                    color:'success',
                    position:'top-right'})
                }).catch((err) => {
                  this.bcd++;
                  this.isExistName1 = true;
                  this.err_message_1 = err;
                  this.closeLoading();
                })
              }
            },
            addServiceInfo(data){
              let temp = JSON.parse(JSON.stringify(data));
              if(!this.isOpenLoading) {
                this.openLoadingInDiv();
              }
              this.abc++;
              this.action_type = 'Add service';
              data.statusFilter = this.serviceStatus
              if(data.category_id == null || data.category_id == '' || data.category_id == 999999) {
                delete data.category_id;
              }
              this.$store.dispatch("serviceList/ADD_SERVICE_POS", data).then(() => {
                setTimeout(() => {
                  if(temp.category_id == ""){
                    temp.category_id = 999999;
                  }
                  const cate = {
                    id: temp.category_id,
                    name: temp.cate_name,
                    type: this.typeCate
                  }
                  this.updateActiveStaff(cate, true);
                }, 100);
                this.closeLoading();
                this.$vs.notify({
                  title:'Notification',
                  text:'Add Service Success',
                  color:'success',
                  position:'top-right'})
              })
            },
            addProductInfo(data){
              if(!this.isOpenLoading) {
                this.openLoadingInDiv();
              }
              this.add_product_key++;
              this.action_type = 'Add product';
              data.statusFilter = this.serviceStatus
              this.$store.dispatch("serviceList/ADD_PRODUCT_POS", data).then(() => {
                setTimeout(() => {
                  const cate = {
                    id: data.category_id,
                    name: data.cate_name,
                    type: this.typeCate
                  }
                  this.updateActiveStaff(cate, true);
                }, 100);
                this.closeLoading();
                this.$vs.notify({
                  title:'Notification',
                  text:'Add Product Success',
                  color:'success',
                  position:'top-right'})
              })
            },
            addComboInfo(data){
              if(!this.isOpenLoading) {
                this.openLoadingInDiv();
              }
              this.add_product_key++;
              this.action_type = 'Add combo';
              data.statusFilter = this.serviceStatus
              this.$store.dispatch("serviceList/ADD_COMBO_POS", data).then(() => {
                setTimeout(() => {
                  const cate = {
                    id: data.category_id,
                    name: data.cate_name,
                    type: this.typeCate
                  }
                  this.updateActiveStaff(cate, true);
                }, 100);
                this.closeLoading();
                this.$vs.notify({
                  title:'Notification',
                  text:'Add Combo Success',
                  color:'success',
                  position:'top-right'})
              })
              this.closeSidebarCombo();
            },
            editServiceInfo(data){
              this.updateServiceData = data;
              this.checkCurrentServiceInCombo(data);
              if(data.status == 0 && this.comboListHasCurrentService.length > 0 && this.comfirmInactiveService == false && this.activeServiceData.status != 0) {
                this.comfirmInactiveService = true;
              } else {
                let temp = JSON.parse(JSON.stringify(data));
                if(!this.isOpenLoading) {
                  this.openLoadingInDiv();
                }
                this.update_service_key++;
                this.action_type = 'Update service';
                data.statusFilter = this.serviceStatus
                if(data.category_id == null || data.category_id == '' || data.category_id == 999999) {
                  delete data.category_id;
                }
                this.$store.dispatch("serviceList/UPDATE_SERVICE_POS" ,data).then(() => {
                  if(temp.category_id == ""){
                    temp.category_id = 999999;
                  }
                  const cate = {
                    id: temp.category_id,
                    type: this.typeCate,
                    color_detail: this.activeStaffData.color_detail
                  }
                  this.updateActiveStaff(cate, true);
                  this.closeLoading();
                  this.comfirmInactiveService = false;
                  this.$refs.updateServiceSidebar.closeSidebar();
                  this.$vs.notify({
                    title:'Notification',
                    text:'Update Service Success',
                    color:'success',
                    position:'top-right'})
                })
              }
            },
            editProductInfo(data){
              if(!this.isOpenLoading) {
                this.openLoadingInDiv();
              }
              this.update_product_key++;
              this.action_type = 'Update product';
              data.statusFilter = this.serviceStatus
              this.$store.dispatch("serviceList/UPDATE_PRODUCT_POS", data).then(() => {
                setTimeout(() => {
                  const cate = {
                    id: data.category_id,
                    name: data.cate_name,
                    type: this.typeCate
                  }
                  this.updateActiveStaff(cate, true);
                }, 100);
                this.closeLoading();
                this.$vs.notify({
                  title:'Notification',
                  text:'Update Product Success',
                  color:'success',
                  position:'top-right'})
              })
            },
            editComboInfo(data){
              if(!this.isOpenLoading) {
                this.openLoadingInDiv();
              }
              this.update_combo_key++;
              this.action_type = 'Update combo';
              data.statusFilter = this.serviceStatus
              this.$store.dispatch("serviceList/UPDATE_COMBO_POS", data).then(() => {
                setTimeout(() => {
                  const cate = {
                    id: data.category_id,
                    name: data.cate_name,
                    type: this.typeCate
                  }
                  this.updateActiveStaff(cate, true);
                }, 100);
                this.closeLoading();
                this.$vs.notify({
                  title:'Notification',
                  text:'Update Combo Success',
                  color:'success',
                  position:'top-right'})
              })
              this.closeSidebarCombo();
            },
            deleteCategory(data){
              data.type = this.typeCate;
              // data.type = 'service';
              // data.list_type = 'pos';
              data.statusFilter = this.status;
              if(!this.isOpenLoading) {
                this.openLoadingInDiv();
              }
              this.action_type = "Delete category";
              this.$store.dispatch("serviceList/DELETE_CATEGORY", data).then(() => {
                this.isEmptyList = false;
                this.dragListType = this.$store.state.serviceList.categoryList.items;
                if(this.$store.getters["serviceList/categoryList"].items && this.$store.getters["serviceList/categoryList"].items.length > 0) {
                  this.updateActiveStaff(this.$store.getters["serviceList/categoryList"].items[0], true);
                } else {
                  this.isEmptyList = true;
                }
                this.closeLoading();
                // this.loaded_data_num++;
                this.$vs.notify({
                  title:'Notification',
                  text:'Delete Category Success',
                  color:'success',
                  position:'top-right'})
              })
            },
            moveCategory(data){
              this.$store.dispatch("serviceList/MOVE_CATEGORY" ,data)
            }
        },
        computed: {
          currentPageCount:{
            get(){
              return this.currentPage;
            },
            set(value){
              this.currentPage = value;
            }
          },
          categoryListAll() {
            return this.$store.state.serviceList.categoryListAll;
          },
          categoryList() {
            return this.$store.state.serviceList.categoryList;
          },
          servicesList(){
            return this.$store.state.serviceList.serviceList;
          },
          config(){
            return this.$store.getters["auth/config"];
          },
          categoryListByType(){
            return this.$store.state.serviceList.categoryListByType;
          },
          serviceListByType(){
            return this.$store.state.serviceList.serviceListByType;
          },
          productListByType(){
            return this.$store.state.serviceList.productListByType;
          },
          comboListByType(){
            return this.$store.state.serviceList.comboListByType;
          },
          allCategoryList() {
            return this.$store.getters["serviceList/allCategoryList"];
          },
          // comboListActive() {
          //   return this.$store.getters['serviceList/comboListActive'];
          // }
        },
        created() {
          const obj = {
            status: this.status,
            // type: 'pos'
            // type : this.typeCate
          }
          // if(this.config && this.config.pos_feature == 1) {
          //   obj.type = 'pos';
          // }
          // this.$store.dispatch("serviceList/GET_CATEGORY_LIST_BY_TYPE", obj).then(() => {
          //   this.dragListType = this.$store.state.serviceList.allCategoryList;
          //   if(this.$store.getters["serviceList/categoryListByType"].items.length > 0) {
          //     this.updateActiveStaff(this.$store.getters["serviceList/categoryListByType"].items[0]);
          //   } else {
          //     this.isEmptyList = true;
          //   }
          //   this.loaded_data_num++;
          // })

          // this.$store.dispatch("serviceList/GET_ALL_CATEGORY_LIST", obj).then(() => {
          //   this.dragListType = this.$store.state.serviceList.allCategoryList;
          //   if(this.$store.getters["serviceList/allCategoryList"].length > 0) {
          //     this.updateActiveStaff(this.$store.getters["serviceList/allCategoryList"][0]);
          //   } else {
          //     this.isEmptyList = true;
          //   }
          //   this.loaded_data_num++;
          // })

          this.$store.dispatch("serviceList/GET_CATEGORY_LIST", obj).then(() => {
            if(this.$store.getters["serviceList/categoryList"].items) {
              this.dragListType = this.$store.getters["serviceList/categoryList"].items;
            }
            if(this.$store.getters["serviceList/categoryList"].items && this.$store.getters["serviceList/categoryList"].items.length > 0) {
              // this.dragListType = this.$store.getters["serviceList/categoryList"].items;
              this.updateActiveStaff(this.$store.getters["serviceList/categoryList"].items[0]);
            } else {
              this.isEmptyList = true;
            }
            this.loaded_data_num++;
          })

          // this.$store.dispatch("serviceList/GET_CATEGORY_LIST").then(() => {
          //   this.dragList = this.$store.state.serviceList.categoryList.items;
          //   if(this.$store.getters["serviceList/categoryList"].items.length > 0) {
          //     this.updateActiveStaff(this.$store.getters["serviceList/categoryList"].items[0]);
          //   } else {
          //     this.isEmptyList = true;
          //   }
          //   this.loaded_data_num++;
          //   this.$store.dispatch("serviceList/GET_CATEGORY_LIST_ALL", {'per-page':"50"})
          // });
        }
    }
</script>

<style lang="scss">
  @import "@/assets/scss/custom/service/_service.scss";
  .filter-list-menu .vs-dropdown--menu--after{
    right: 19px !important;
  }

</style>
